import {
    get
} from 'lodash';
import {
    createUniformSetting
} from '@patsnap/uniform-setting';
import {
    psAxios
} from '@patsnap/common-ps-http';
import { ACCOUNT_SERVICE_URI } from 'library-@/config/apiConfig';

let setting = null;

function initLocale(isLogin = true) {
    const region = get(window, 'zPREFACE.accountInfo.site_region', 'US').toLocaleLowerCase();
    if (setting) {
        setting.locale.LoginIn = isLogin;
    } else {
        setting = createUniformSetting({
            region,
            loggedIn: isLogin,
            baseAccountUrl: ACCOUNT_SERVICE_URI,
            axiosInstance: psAxios,
        });
    }
    return setting;
}

export async function getLangValue(isLogin) {
    const {
        default: default_lang,
        user
    } = await initLocale(isLogin).locale.getLocale();
    return user || default_lang;
}

export async function setLangValue(lang, isLogin) {
    await initLocale(isLogin).locale.setLocale(lang);
}

export async function getClientUUID(isLogin) {
    let clientUUID = await initLocale(isLogin).env.getClientUUID();
    return clientUUID;
}
